import React, { FC } from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as Carpool } from '@assets/svg/icons/logbook/Carpool.svg';

type Props = {
  id: string;
  signatureCode: string;
};

const TripIdRow: FC<Props> = ({ id, signatureCode }: Props) => {
  const [, isCarpooled] = id.split('|');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 4 }}>
      #{signatureCode}
      {isCarpooled === 'true' && (
        <div style={{ marginTop: 8, marginLeft: 16 }}>
          <Tooltip title="Rideshared Trip">
            <Carpool />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default TripIdRow;
